import type { ReactNode } from "react";

/** The site's footer, shared with blog/ like SiteHeader. `children` go under
 *  the signature, for a page with credits of its own. */
export function SiteFooter({ children }: { children?: ReactNode }) {
  return (
    <footer className="container">
      <div style={{ textAlign: "center", padding: "2rem 0", borderTop: "1px solid var(--pico-muted-border-color)", marginTop: "3rem" }}>
        <small>Made in 🐴 Saratoga Springs, NY</small>
        {children}
      </div>
    </footer>
  );
}
